import { Route, Routes } from 'react-router-dom';
import Home from "./pages/home/home";

function App() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
